<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



 //  CUSTOM JS START HERE

//  Product & Collection Toggle Scripts 

document.addEventListener('click', function(e) {
  var target = e.target;
  
  var isToggleMore = target.classList.contains('toggle-more') || 
                     target.parentElement?.classList.contains('toggle-more');
  var isToggleLess = target.classList.contains('toggle-less') || 
                     target.parentElement?.classList.contains('toggle-less');
  
  if (!isToggleMore && !isToggleLess) return;
  
  var toggleElement = target.classList.contains('toggle-more') || 
                      target.classList.contains('toggle-less') ? 
                      target : target.parentElement;
  
  var wrapper = toggleElement.closest('.desc-toggle');
  if (!wrapper) return;
  
  var shortDesc = wrapper.querySelector('.desc-short');
  var longDesc = wrapper.querySelector('.desc-long');
  
  if (!shortDesc || !longDesc) return;
  
  if (isToggleMore) {
    shortDesc.style.display = 'none';
    longDesc.style.display = 'block';
  } else if (isToggleLess) {
    shortDesc.style.display = 'block';
    longDesc.style.display = 'none';
  }
});


{/* Collection Read More Toggle */}
(function() {
  var btn = document.getElementById('readMoreBtn');
  var content = document.getElementById('expandContent');

  if (!btn || !content) return;

  btn.addEventListener('click', function() {
    content.classList.toggle('expanded');
    btn.textContent = content.classList.contains('expanded') ? 'Show Less' : 'Read More';
  });
})();